export default __webpack_public_path__ + "static/media/prateek.edd744f8.jpeg";